<template>
  <div class="search-box">
    <a-input @change="updateText" type="text" name="recored-search" :placeholder="$t('common.search')" />
  </div>
</template>

<script>
export default {
  emits: ['update:text', 'textChanged'],
  data() {
    return {
      text: '',
    };
  },
  methods: {
    updateText(e) {
      if (e.target.value.trim()) {
        this.text = e.target.value.trim();
      } else {
        this.text = '';
      }
      this.$emit('update:text', this.text);
      this.$emit('textChanged');
    },
  },
};
</script>
